import { render, staticRenderFns } from "./ViewCardTemplate.vue?vue&type=template&id=cfe132fe&scoped=true&"
import script from "./ViewCardTemplate.vue?vue&type=script&lang=js&"
export * from "./ViewCardTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ViewCardTemplate.vue?vue&type=style&index=0&id=cfe132fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfe132fe",
  null
  
)

export default component.exports